import { Paths } from 'src/constants/paths'

/**
 * ログイン画面でSSOログインボタンを表示させるURLパラメータ。
 *
 * パラメータ名と値の定義はここだけに置く。表示判定と、SSOフローからログイン画面へ戻す
 * リダイレクトの両方がこれを参照するため、片方だけ書き換わるとボタンが出なくなる。
 */
export const ssoLoginParam = { name: 'login', value: 'sso' } as const

/**
 * SSOパラメータを付けたログイン画面のパスを組み立てる。
 *
 * SSOフローからログイン画面へ戻すリダイレクトで使う。素の`Paths.Login`へ戻すと
 * パラメータが落ちて、dctではSSOログインボタンが消えてしまう。
 */
export const loginPathWithSSOParam = (): string =>
  `${Paths.Login}?${ssoLoginParam.name}=${ssoLoginParam.value}`
